import { Component, HostListener, Inject, OnInit } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { AuthenticatedUserService } from './core/services/authenticated-user/authenticated-user.service';
import { TranslationService } from './core/services/translation/translation.service';
import { UserGuard } from './shared/guards/user/userGuard';
import { translocoLang } from './utils/translocoLang';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
/**
   TODO: JSDoc
 **/
export class AppComponent implements OnInit {
  /**
   * @constructor
   */
  constructor(
    private translationService: TranslationService,
    public userGuard: UserGuard,
    private readonly authenticatedUserService: AuthenticatedUserService,
    private readonly swUpdate: SwUpdate,
    @Inject('Window') private readonly window: Window
  ) {}

  /**
   * ng on init
   */
  ngOnInit(): void {
    this.translationService.setActiveLang(localStorage.getItem(translocoLang)!);
    this.authenticatedUserService.initializeAdmin();
    this.swUpdate.versionUpdates.subscribe((event) => {
      if (event.type === 'VERSION_READY') {
        location.reload();
      }
    });
  }

  /**
   * Forces a full reload when the page is restored from the browser's
   * back-forward cache, so guards and interceptors re-validate the session
   * instead of showing a stale, already-authenticated screen
   * @param {PageTransitionEvent} event
   */
  @HostListener('window:pageshow', ['$event'])
  onPageShow(event: PageTransitionEvent): void {
    if (event.persisted) {
      this.window.location.reload();
    }
  }
}
